import type { Persister } from "@tanstack/react-query-persist-client";
import * as React from "react";

export const PersistResetContext = React.createContext<
  Persister["removeClient"] | null
>(null);

export const usePersistResetContext = () => {
  const context = React.use(PersistResetContext);

  if (!context)
    throw new Error("usePersistResetContext must be used inside AppProvider");

  return context;
};
